module.exports = __webpack_public_path__ + "img/westudy_team.d43aa918.png";